export default {
  lg: [
    { w: 1, h: 2, x: 0, y: 0, i: 'graph1' }, // Takes up 1 column
    { w: 1, h: 2, x: 1, y: 0, i: 'graph2' }, // Takes up 1 column
    { w: 1, h: 2, x: 2, y: 0, i: 'graph3' }, // Takes up 1 column
    { w: 1, h: 2, x: 0, y: 1, i: 'graph4' }, // Starts on the next row
    { w: 1, h: 2, x: 1, y: 1, i: 'graph5' }, // Next to graph4
    { w: 1, h: 2, x: 2, y: 1, i: 'graph6' }, // Next to graph5
    { w: 1, h: 2, x: 0, y: 2, i: 'graph7' }, // Starts the third row
  ],
  md: [
    {
      w: 6,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph1',
    },
    {
      w: 4,
      h: 2,
      x: 6,
      y: 0,
      i: 'graph2',
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph3',
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 0,
      i: 'graph4',
    },
    {
      w: 4,
      h: 2,
      x: 6,
      y: 2,
      i: 'graph5',
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: 'graph6',
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 2,
      i: 'graph7',
    },
  ],
  sm: [
    {
      w: 6,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph1',
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph2',
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 0,
      i: 'graph3',
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph4',
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: 'graph5',
    },
    {
      w: 3,
      h: 2,
      x: 0,
      y: 2,
      i: 'graph6',
    },
    {
      w: 3,
      h: 2,
      x: 3,
      y: 2,
      i: 'graph7',
    },
  ],
  xs: [
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph1',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph2',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph3',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      i: 'graph4',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: 'graph5',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: 'graph6',
    },
    {
      w: 4,
      h: 2,
      x: 0,
      y: 2,
      i: 'graph7',
    },
  ],
};
